import { useSelector } from 'react-redux';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PromotionBanner from 'pricing-pages-ui-components/banners/PromotionBanner';
import { allEligibleDiscountsSelector } from 'pricing-pages-ui/selectors/PromotionSelectors';
import { promotionKeys } from 'self-service-api/constants/Promotions';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PromotionBannerContainer = () => {
  const isAppReady = useGlobalLoading();
  const eligibleDiscounts = useSelector(allEligibleDiscountsSelector);
  const isEligibleForPromotion = promotionKey => eligibleDiscounts.includes(promotionKey);
  if (!isAppReady) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isEligibleForPromotion(promotionKeys.HSFS_SEED_V2) && /*#__PURE__*/_jsx(PromotionBanner, {
      promotion: promotionKeys.HSFS_SEED_V2,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.promotions.hsfx.seed.title`
      }),
      description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `pricingPage.promotions.hsfx.seed.body_jsx`,
        elements: {}
      })
    }), isEligibleForPromotion(promotionKeys.HSFS_SEED_V3) && /*#__PURE__*/_jsx(PromotionBanner, {
      promotion: promotionKeys.HSFS_SEED_V3,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.promotions.hsfx.seedV3.title`
      }),
      description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `pricingPage.promotions.hsfx.seedV3.body_jsx`,
        elements: {}
      })
    }), isEligibleForPromotion(promotionKeys.HSFX_ENTREPRENEUR_V2) && /*#__PURE__*/_jsx(PromotionBanner, {
      promotion: promotionKeys.HSFX_ENTREPRENEUR_V2,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'pricingPage.promotions.hsfx.entrepreneur.title'
      }),
      description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `pricingPage.promotions.hsfx.entrepreneur.body_jsx`,
        elements: {}
      })
    }), isEligibleForPromotion(promotionKeys.HSFX_BOOTSTRAP) && /*#__PURE__*/_jsx(PromotionBanner, {
      promotion: promotionKeys.HSFX_BOOTSTRAP,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.promotions.hsfx.bootstrap.title`
      }),
      description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `pricingPage.promotions.hsfx.bootstrap.body_jsx`,
        elements: {}
      })
    }), isEligibleForPromotion(promotionKeys.STRATEGIC_PARTNERSHIP) && /*#__PURE__*/_jsx(PromotionBanner, {
      promotion: promotionKeys.STRATEGIC_PARTNERSHIP,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.promotions.hsfx.strategicPartner.title"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.promotions.hsfx.strategicPartner.body"
      })
    }), isEligibleForPromotion(promotionKeys.HSFS_SERIES_A_V2) && /*#__PURE__*/_jsx(PromotionBanner, {
      promotion: promotionKeys.HSFS_SERIES_A_V2,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.promotions.hsfx.series-a.title`
      }),
      description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `pricingPage.promotions.hsfx.series-a.body_jsx`,
        elements: {}
      })
    })]
  });
};
export default PromotionBannerContainer;